export default __webpack_public_path__ + "static/media/member-register-promo.4e9c2599.png";